import { units } from "../units";

type Props = {
  viewport: {
    min: number;
    max: number;
  };
  clamp: {
    min: number;
    max: number;
  };
};

/**
 * linearly clamps a value dynamically based on the current viewport width.
 *
 * @see https://css-tricks.com/linearly-scale-font-size-with-css-clamp-based-on-the-viewport/
 *
 * @example
 * ```
 * linearClamp({ viewport: { min: 100, max: 200 }, clamp: { min: 50, max: 100 } })
 *    // --> 100px IF viewport.innerWidth >= 200px
 *    // --> 75px IF viewport.innerWidth == 150px
 *    // --> 50px IF viewport.innerWidth <= 100px
 * ```
 */
export const linearClamp = (options: Props) => {
  const slope =
    (options.clamp.max - options.clamp.min) /
    (options.viewport.max - options.viewport.min);
  const yAxisIntersection = -options.viewport.min * slope + options.clamp.min;

  return `clamp(${units.px(options.clamp.min)}, ${units.px(
    yAxisIntersection,
  )} + ${units.vw(slope * 100)}, ${units.px(options.clamp.max)})`;
};
